
<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     标签管理器
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="tag-manager" :class="{ 'fold': fold, 'no-collapse': !collapse }">
    <el-scrollbar :native="false">
      <div class="manager-card" v-if="!fold" v-loading="loading" shadow="never" :body-style="{ 'padding': 0 }">
        <div class="flex column">
          <div class="left">
            <div class="manager-head flex align-items-center">
              <div class="bd font-md pl-lg">
                <slot name="tag-name">
                  标签管理
                </slot>
              </div>
              <div class="ft">
                <i class="el-icon-plus mr-lg icon-button small" @click="postTag()" />
              </div>
            </div>
            <div class="manager-body">
              <div class="tag-item flex" :class="{ 'text-success': !tagid }" role="button" @click="clickTag()">
                <span class="pl-lg">全部{{ typeMap[type] }}</span>
              </div>

              <draggable v-model="tags" @update="handleSortChange" handle=".mover">
                <transition-group type="transition">
                  <div v-for="tag in tags" :key="tag.tagid" class="tag-item flex"
                    :class="{ 'active': tag.tagid == tagid, 'active-drop': tag.tagid == active_tagid }"
                    @click.stop="clickTag(tag)">
                    <div class="hd mover">
                      <el-tooltip content="拖动调整顺序" placement="left" :open-delay="500">
                        <span class="iconfont icon-button icon-drag small"></span>
                      </el-tooltip>
                    </div>
                    <div class="bd flex ml-md" :class="{ 'text-success': tag.tagid == tagid }">
                      <span class="ellipsis" v-overflow-tooltip style="max-width: 120px;">{{ tag.title }}</span>
                      <span class="spot mr-sm ml-sm">.</span>
                      <span class="">{{ tag.count }}</span>
                    </div>
                    <div class="ft flex-center">
                      <div class="" @click.stop>
                        <el-dropdown trigger="click" placement="bottom-start" @visible-change="visibleChange">
                          <el-tooltip content="更多" placement="top" :open-delay="500">
                            <span class="iconfont icon-button icon-more small-sm more"
                              :class="{ 'active': tag.tagid == active_tagid }" @click="active_tagid = tag.tagid">
                            </span>
                          </el-tooltip>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="postTag(tag)"><i
                                class="el-icon-edit mr-sm icon-button small"></i>编辑</el-dropdown-item>
                            <el-dropdown-item @click.native="deleteTag(tag)"><i
                                class="el-icon-delete mr-sm icon-button small"></i>删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <div class="right" :class="[!collapse && 'active', isEnter && 'show']" @mouseenter="handleEnter"
            @mouseleave="handleLeave" @mousemove="handleMove">
            <el-tooltip content="关闭标签管理器" placement="top" :open-delay="500">
              <span class="iconfont icon-button icon-circle-left manager" @click="togglePanel(1)"></span>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div v-else class="icon-button flex justify-content-center">
        <el-tooltip content="打开标签管理器" placement="top" :open-delay="500">
          <span class="iconfont icon-button icon-circle-right mt-sm" :class="{ 'active': tagid }" @click="togglePanel(0)"></span>
        </el-tooltip>
      </div>

    </el-scrollbar>

    <div v-if="foot" class="slot-foot flex-center"
      :class="[fold && 'foot-width', !collapse && 'active', foot && 'foot-color']">
      <slot name="recycle">
      </slot>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { getallApi, postApi, deleteApi, sortApi } from "@/api/fam/famTagApi";
export default {
  name: "TagManager",

  components: {
    draggable
  },

  props: {
    value: {
      type: Number,
      default: undefined
    },

    type: {
      type: String,
      default: "equip"
    },

    foot: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      typeMap: {
        equip: "设备",
        dev: "模型",
        member: "用户"
      },
      fold: 0,

      loading: false,
      tags: [],

      inputPopShow: false,
      inputName: "",
      inputValid: true,
      active_tagid: null,
      isEnter: false
    };
  },

  computed: {
    tagid: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    collapse() {
      return this.$store.state.commonStore.collapse;
    }
  },

  created() {
    this.fold = Number(
      localStorage.getItem(`__TAG_MANAGER_FOLD_${this.type.toUpperCase()}__`)
    );
    this.fetchData(true);
    this.$emit("change", 0);
  },

  methods: {
    handleEnter() {
      this.isEnter = true;
    },
    handleLeave() {
      this.isEnter = false;
    },
    handleMove() {
      this.isEnter = true;
    },
    visibleChange(e) {
      if (!e) this.active_tagid = null;
    },
    togglePanel(fold) {
      this.fold = fold;
      localStorage.setItem(
        `__TAG_MANAGER_FOLD_${this.type.toUpperCase()}__`,
        fold
      );
      this.$emit("toggle", this.fold);
      if (this.fold == 1) this.isEnter = false;
    },

    fetchData(loading = false) {
      if (loading) this.loading = true;
      getallApi({ type: this.type }).then(res => {
        this.loading = false;
        if (!res.errno) {
          this.tags = res.data.list;
        }
      });
    },

    clickTag(tag) {
      if (tag && tag.tagid) {
        this.tagid = tag.tagid;
      } else {
        this.tagid = 0;
      }
      this.$emit("change", this.tagid);
    },

    postTag(tag) {
      const _this = this;
      let isFirstValidate = true; // 标记是否为首次校验

      const inputValidator = (value) =>{
        // 首次校验（框架初始化触发）直接通过，后续执行真实校验
        if (isFirstValidate) {
          isFirstValidate = false;
          return true;
        }
        if (tag && tag.title == value) return "名称未修改";
        for (const v of _this.tags) {
          if (v.title == value) return "标签已存在，请勿重复";
        }
        return true;
      }
      this.$prompt("", `${tag ? "编辑" : "新建"}标签`, {
        inputValue: tag ? tag.title : "",
        inputValidator: inputValidator,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          if (value.length != 0 && value.trim().length != 0) {
            postApi(
              Object.assign({}, tag, { type: this.type, title: value })
            ).then(res => {
              if (!res.errno) {
                this.$message.success("操作成功！");
                this.fetchData();
                this.$emit("update");
                if (!tag) {
                  this.$emit("create");
                } else {
                  this.$emit("edit");
                }
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            this.$message.error("名称不能为空");
          }
        })
        .catch(() => {
          // 取消
        });
    },

    handleSortChange() {
      const tagids = this.tags.map(v => v.tagid);
      sortApi({ type: this.type, tagids }).then(res => {
        if (res.errno === 0) {
          this.fetchData();
          this.$emit("sort");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    deleteTag(tag) {
      this.$confirm(`即将删除标签「${tag.title}」，是否继续？`, "操作确认", {
        type: "error"
      })
        .then(() => {
          deleteApi({ type: this.type, tagid: tag.tagid }).then(res => {
            if (res.errno === 0) {
              this.$message.success("操作成功！");
              this.fetchData();
              this.$emit("delete");
              if (this.tagid == tag.tagid) {
                this.clickTag();
              }
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    }
  }
};
</script>

<style lang="scss">
.tag-manager {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  padding: 0 0px;
  border: none;
  border-right: 1px solid #eee;

  .el-scrollbar__bar.is-vertical>div {
    display: none;
  }


  &.fold {
    width: 60px;
  }

  &.no-collapse {
    border-bottom-left-radius: 20px;
  }

  .icon-button {
    line-height: 36px;
    font-size: 24px;
    color: #999;
    cursor: pointer;
    transition: color 0.2s;

    &.small {
      font-size: 18px;
    }

    &.small-sm {
      font-size: 15px;
    }

    &:hover {
      color: #333;
    }

    &.active {
      color: #07C160;
    }

    .iconfont {
      &:hover {
        color: #07C160;
      }
    }
  }

  .manager-card {
    height: 100%;
    border: none;

    .right {
      height: 100%;
      width: 16px;
      position: fixed;
      left: 290px;
      z-index: 2;

      &.active {
        left: 391px;
      }

      &.show {
        &::after {
          width: 3px;
          height: 100%;
          position: absolute;
          background-color: #07c160;
          right: 6px;
          top: 0;
          content: "";
        }
      }

      .manager {
        display: none;
        height: 24px;
        line-height: 24px;
        width: 24px;
        font-size: 24px;
        border-radius: 50%;
        position: absolute;
        left: -4px;
        top: 19px;
        z-index: 99;
        background-color: rgba(249, 249, 249, 1);

        &:hover {
          color: #07C160;
        }
      }

      &:hover {
        cursor: e-resize;
        .manager {
          display: block;
        }
      }
    }
  }

  .manager-head {
    height: 60px;
  }

  .manager-body {
    margin: 0 0 15px 0;

    .tag-item {
      user-select: none;
      height: 36px;
      line-height: 36px;
      transition: background-color 0.2s, transform 0.5s;

      &.text-success {
        background-color: rgba(7, 193, 96, 0.05);
      }

      >.hd {
        width: 32px;
        padding: 0 7px;
      }

      .iconfont {
        display: none;
        transition: display 0.2s;
      }

      .more {
        border-radius: 4px;
        width: 24px;
        text-align: center;
        margin-right: 10px;

        &:hover,
        &.active,
        &:focus {
          display: block;
          height: 24px;
          line-height: 24px;
          background-color: #e3e8ec;
        }
      }

      &:hover {
        background-color: #f5f7fa;

        .iconfont {
          display: block;
        }

        >.hd span {
          cursor: move;
        }
      }

      &.active {
        background-color: rgba(7, 193, 96, 0.05);

        .more {
          display: block;
        }
      }

      &.active-drop {
        .more {
          display: block;
        }
      }
    }
  }

  >.el-scrollbar {
    height: calc(100% - 60px);

    >.el-scrollbar__wrap {
      overflow-x: hidden;

      >.el-scrollbar__view {
        padding: 0 0 10px 0;
      }
    }
  }
}

.spot {
  line-height: 30px;
  font-weight: 900;
}

.slot-foot {
  width: 240px;
  position: fixed;
  bottom: 0;
  left: 60px;
  height: 60px;
  background-color: rgba(255, 255, 255, 1);
  z-index: 3;

  // border-top: 3px solid rgba(255, 255, 255, 1);
  &.foot-color {
    height: 59px;
    background-color: rgba(249, 249, 249, 1);
    border-top: 1px solid rgba(249, 249, 249, 1);
  }

  &.active {
    left: 160px;
    border-bottom-left-radius: 20px;
  }

  &.foot-width {
    width: 60px;
  }
}

.el-tooltip__popper.is-dark.tagmanager {
  max-width: 200px;
}
</style>
